<template>
  <div class="h-100">
    <b-col class="settings-panel">
      <div class="card">
        <div class="card-header text-center">
          Account Settings
        </div>

        <b-col md="8" class="settings-panel-body accountsettings" v-if="form">
          <div class="card-block">
            <b-form>
              <div class="text-right p-3">
                <b-btn variant="outline-secondary" @click="$emit('action',{action:'loginActivity'})">
                  <door-icon class="icon-default door"></door-icon> View login activity
                </b-btn>
              </div>
              <legend class="m-50">Login Details</legend>
              <b-form-group id="exampleInputGroup1" label="Email" label-for="email" class="px-2 m-50">
                <b-form-input id="email" type="text" v-model="form.email" required>
                </b-form-input>
                <b-btn variant="link" @click="toggleChangePassword" size="sm">change password</b-btn>
              </b-form-group>
              <div v-if="showChangePassword">
                <b-form-group id="exampleInputGroup1" label="Current Password" label-for="current_password" class="px-2 m-50">
                  <password-input idFor="current_password" v-model="form.currentPassword"></password-input>
                  <p class="error-message" v-if="showErrorMessage">
                    {{errorMessage}}
                  </p>
                </b-form-group>
                <b-form-group id="exampleInputGroup1" label="New Password" label-for="new_password" class="px-2 m-50">
                  <password-input idFor="new_password" v-model="form.newPassword"></password-input>
                </b-form-group>
              </div>
              <hr/>
              <div class="text-right p-3">
                <b-btn variant="outline-secondary" @click="sendTestEmail">
                  <paper-rocket-icon class="icon-default paperrocket"></paper-rocket-icon>Send Test email
                  <spinner size="small" v-if="buttonLoaders.sendTestEmail"></spinner>
                </b-btn>
              </div>
              <legend class="m-50">Email Notifications</legend>
              <b-form-group label="Notify about updates to" label-for="checkboxes2" class="px-2 m-50">
                <!-- <b-form-checkbox-group id="checkboxes2" name="flavour2" class="d-inline-flex"> -->
                <b-form-checkbox class="mx-1" v-model="form.updatesNotificationMail.pluginUpdates" value="1" unchecked-value="0">Plugins</b-form-checkbox>
                <b-form-checkbox class="mx-1" v-model="form.updatesNotificationMail.themeUpdates" value="1" unchecked-value="0">Themes</b-form-checkbox>
                <b-form-checkbox class="mx-1" v-model="form.updatesNotificationMail.coreUpdates" value="1" unchecked-value="0">Wordpress</b-form-checkbox>
                <b-form-checkbox class="mx-1" v-model="form.updatesNotificationMail.translationUpdates" value="1" unchecked-value="0">Translations</b-form-checkbox>
                <!-- </b-form-checkbox-group> -->
              </b-form-group>
              <b-form-group label="Email me every" label-for="email_freq" class="mode-group px-2 m-50">
                <b-form-radio-group button-variant="outline-custom" id="email_freq" buttons v-model="form.updatesNotificationMail.frequency" :options="options" name="radiosBtnDefault" />
              </b-form-group>
            </b-form>
            <p class="helper-note p-2 m-50 py-4">
              <info-round-icon class="icon-default inforound"></info-round-icon>
              You have to set a cron job for this to work. (suggested timing: every 20 min)
            </p>
          </div>
        </b-col>

        <div class="card-footer text-muted text-right">
          <b-btn variant="primary" size="sm" @click="save">Save Changes
            <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
          </b-btn>
        </div>
      </div>
    </b-col>
  </div>
</template>

<script>
import _ from 'lodash';

import PasswordInput from '../Common/PasswordInput';
import PaperRocketIcon from '../../assets/paperrocket.svg';
import DoorIcon from '../../assets/door.svg';
import InfoRoundIcon from '../../assets/inforound.svg';

export default {
  name: 'accountsettings',
  props: ['settings'],
  components: {
    PasswordInput,
    PaperRocketIcon,
    InfoRoundIcon,
    DoorIcon
  },
  computed: {
    form() {
      let form = {};
      if (this.settings) {
        let settings = _.cloneDeep(this.settings);
        form = settings.accountSettings;
      }
      return form;
    }
  },
  data() {
    return {
      passwordType: 'password',
      buttonLoaders: {
        saveChanges: false,
        sendTestEmail: false
      },
      showChangePassword: false,
      showErrorMessage: false,
      errorMessage: '',
      selected: 'daily',
      testMailStatus: null,
      options: [
        { text: 'Daily', value: 'daily' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Never', value: 'never' }
      ]
    };
  },
  methods: {
    toggleChangePassword() {
      this.showChangePassword = !this.showChangePassword;
    },
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      if (this.showChangePassword) {
        if (
          typeof this.form.currentPassword == 'undefined' ||
          typeof this.form.newPassword == 'undefined' ||
          this.form.currentPassword.length == 0 ||
          this.form.newPassword.length == 0
        ) {
          this.showErrorMessage = true;
          this.errorMessage = 'Please enter the current password.';
          return;
        }
      }

      payload.requiredData = {
        updateSettingsAllV3: {
          accountSettings: this.form
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
        this.showErrorMessage = false;
        if (
          response.data.updateSettingsAllV3 &&
          response.data.updateSettingsAllV3.error &&
          response.data.updateSettingsAllV3.error === 'invalid_password'
        ) {
          this.showErrorMessage = true;
          this.errorMessage =
            'You seem to have got the current password wrong. Please check it.';
          setTimeout(() => {
            this.showErrorMessage = false;
          }, 3000);
        }
      });
    },
    sendTestEmail() {
      this.buttonLoaders.sendTestEmail = true;
      let payload = {};
      payload.requiredData = {
        updatesNotificationMailTest: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.sendTestEmail = false;
        this.testMailStatus =
          response.data.updatesNotificationMailTest === true
            ? 'success'
            : 'failed';
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Settings/AccountSettings.vue